import React from "react";
import { Modal } from "antd";
import axios from "axios";
import moment from "moment/moment";
import { t } from "i18next";
import swal from "sweetalert";
import { Util } from "common/util";
import {
   Button,
   InputDate,
   InputTextArea,
   SelectInput,
   Spin,
   Upload,
   Form,
   PaperClipOutlined
} from "common/elements";
import {
   insertNewRecord,
   getRecentlyPaternityLeave,
   getRounedNumberOfDayMaternityLeave,
   getNumberOfDay
} from "services/leave";
import { getLeaveTypes } from "services/employee";
import { getURl } from "services/core";
import Enum from "common/enums";
import "./index.css";

const { Dragger } = Upload;

function Attachment({ required, errorMessage, title, callback }) {
   const [attachmes, setAttachments] = React.useState([]);

   const onUploadFile = (options) => {
      const { onSuccess, file } = options;
      const formData = new FormData();
      const config = {
         headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${Util.getInstance().getAccessToken()}`,
         },
      };
      const duplicateFile = attachmes.find((value) => value.name === file.name);
      if (duplicateFile) {
         Util.getInstance().sweetAlertMessage("This file already exists!", "warning");
      } else {
         formData.append("attachment", file, file.name);
         axios
            .post(`${getURl()}/file/v1/leave/attachment`, formData, config)
            .then((response) => {
               onSuccess("Ok");
               const file = {
                  uid: Date.now(),
                  name: response.data.originalname,
                  destination: response.data.destination,
                  status: "done",
                  url: `${getURl()}/${response.data.path}`,
               };

               setAttachments([file]);

               callback(`${response.data.destination}/${file.name}`);
            })
      }
   };

   const onRemoveFile = (file) => {
      axios({
         method: "DELETE",
         url: `${getURl()}/file/v1/delete_leave?path=${file.destination}&file=${file.name}`,
         headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Util.getInstance().getAccessToken()}`,
         },
      })
         .then(() => {
            setAttachments([]);
            callback(file);
         });

   }

   return <Form.Item
      name="attachment"
      label={title}
      rules={[
         {
            required,
            message: errorMessage,
         },
      ]}
   >
      <Dragger
         className={`ant-form-item ${attachmes.length ? "has-uploaded-file" : ""}`}
         customRequest={onUploadFile}
         multiple={false}
         onRemove={onRemoveFile}
         fileList={attachmes}
      >
         {
            attachmes.length === 0 &&
            <>
               <p className="ant-upload-drag-icon" style={{ marginBottom: 5 }}>
                  <PaperClipOutlined style={{ fontSize: 35 }} />
               </p>
               <p className="ant-upload-hint">
                  Click or drag file on this to upload
               </p>
            </>
         }
      </Dragger>
   </Form.Item>
}

export default class FormInsertOrUpdate extends React.PureComponent {
   state = {
      id: null,
      selectedLeaveType: null,
      recentlyPaternityLeave: null,
      numberOfDay: 0,
      visible: false,
      loading: false,
      loadingFormData: false,
      attachment: null,
      leaveTypes: []
   };

   componentDidMount() {
      getLeaveTypes()
         .then((response) => {
            if (response.data) {
               this.setState({ leaveTypes: response.data });
            }
         });
   }

   fetchNumberOfDay = (startDate, endDate,startShift,endShift) => {
      if (startDate && endDate) {
         this.setState({ loadingFormData: true })
         getNumberOfDay(moment(startDate).format("YYYY-MM-DD HH:mm"), moment(endDate).format("YYYY-MM-DD HH:mm"),startShift,endShift, this.state.selectedLeaveType)
            .then(response => {
               if (response.data) {
                  this.setState({ numberOfDay: response.data.numberOfDays });
               }
            })
            .finally(() => {
               this.setState({ loadingFormData: false });
            });
      }
   }

   fetchEndDateOfMaternity = (startDate, endDate) => {
      if (startDate && endDate) {
         this.setState({ loadingFormData: true })
         getRounedNumberOfDayMaternityLeave(moment(startDate).format("YYYY-MM-DD HH:mm"), moment(endDate).format("YYYY-MM-DD HH:mm"), this.state.selectedLeaveType)
            .then(response => {
               console.log(response)
               if (response.data) {
                  const { data } = response;
                  this.setState({ numberOfDay: data.numberOfDays || 126 });
                  endDate = moment(data.hoursOfLeaveByDays[data.hoursOfLeaveByDays.length - 1].date);
                  this.props.form.setFieldsValue({ endDate });
               }
            })
            .finally(() => {
               this.setState({ loadingFormData: false });
            });
      }
   }

   fetchRecentlyPaternity = () => {
      getRecentlyPaternityLeave()
         .then(response => {
            if (response.data && moment.duration(moment().diff(moment(response.data.end))).asYears() < 1) {
               this.setState({ recentlyPaternityLeave: response.data });
            }
         });
   }

   showModal = (leaveType) => {
      this.setState({
         visible: true,
         selectedLeaveType: leaveType
      });

      const foundLeaveType = this.state.leaveTypes.find(value => value.type === leaveType);
      this.props.form.setFieldsValue({ leaveItemId: foundLeaveType?.id });
   }

   closeModal = () => {
      this.setState({
         visible: false,
         numberOfDay: null,
         recentlyPaternityLeave: null
      });
      this.props.form.resetFields();
   }

   handleCancel = () => {
      this.closeModal();
   };

   isShowAttachment = (selectedLeaveType, numberOfDay) => {
      if (selectedLeaveType === Enum.LEAVE_TYPE.SICK_LEAVE && numberOfDay >= 3) return true;
      if (selectedLeaveType === Enum.LEAVE_TYPE.PATERNITY_LEAVE && numberOfDay >= 10) return true;

      return false;
   }

   getDisabledStartDate = (current) => {
      let disabled = false;
      
      const selectedLeaveType = this.state.selectedLeaveType;
      const endDate = this.props.form.getFieldValue("endDate");

      // Check if the current date is before the selected start date
      if ( endDate && current > moment(endDate) ) {
         disabled = true;

         // Check if the current date is diff from end date of month
      } else if ( endDate && current.month() !== moment(endDate).month() && selectedLeaveType === Enum.LEAVE_TYPE.COMPENSATION ) {
         disabled = true;
      }
      
      return disabled;
   }

   getDisabledEndDate = (current) => {
      let disabled = false;

      const selectedLeaveType = this.state.selectedLeaveType;
      const startDate = this.props.form.getFieldValue("startDate");

      // Check if the current date is before the selected start date
      if (startDate && current < moment(startDate)) {
         disabled = true;

         // Check if the current date is diff from start date of month
      } else if (current.month() !== moment(startDate).month() && selectedLeaveType === Enum.LEAVE_TYPE.COMPENSATION) {
         disabled = true;
      }
      
      return disabled;
   }

   getStartDate = (startDate, startShift) => {
      let startTime = "08:00";

      if (startShift === "PM") {
         startTime = "13:00";
      }

      return moment(`${startDate.format("YYYY-MM-DD")} ${startTime}`);
   }

   getEndDate = (endDate, startShift) => {
      let endTime = "17:00";

      if (startShift === "AM") {
         endTime = "12:00";
      }

      return moment(`${endDate.format("YYYY-MM-DD")} ${endTime}`);
   }

   onFinish = (values) => {
      values["employeeId"] = Util.getInstance().getCurrentUser()?.id;
      values["attachment"] = this.state.attachment;
      values["numberOfDay"] = this.state.numberOfDay;

      values["startDate"] = moment(values.startDate).format("YYYY-MM-DD HH:mm");
      values["endDate"] = moment(values.endDate).format("YYYY-MM-DD HH:mm");
      
      if (this.state.selectedLeaveType === Enum.LEAVE_TYPE.SICK_LEAVE && this.state.numberOfDay > 3 && !values["attachment"]) {
         swal({
            title: "Certificate from Doctor Not Submitted",
            text: "No certificate has been uploaded. Would you like to request annual leave instead?",
            icon: "warning",
            buttons: ["No", "Yes"],
            dangerMode: true,
         })
            .then(yes => {
               if (yes) {
                  const foundLeaveType = this.state.leaveTypes.find(value => value.type === Enum.LEAVE_TYPE.ANNUAL_LEAVE);
                  this.setState({ selectedLeaveType: Enum.LEAVE_TYPE.ANNUAL_LEAVE });
                  this.props.form.setFieldsValue({ leaveItemId: foundLeaveType?.id });
               }
            });
         return;
      }

      this.setState({ loading: true });
      insertNewRecord(values)
         .then(() => {
            this.closeModal();
            this.props.onSuccess();
         })
         .catch((error) => {
            const message = error?.response?.data?.error?.message;
            const code = error?.response?.data?.error?.code;
            if (code === 600) {
               swal({
                  title: "Insufficient Leave Balance",
                  text: message,
                  icon: "error",
                  dangerMode: true,
               });
            } else if (error?.response?.status === 400) {
               swal({
                  title: "Leave Request Detected",
                  text: error.response.data.error.message,
                  icon: "error",
                  dangerMode: true,
               });
            } else if (code === 700) {
                swal({
                    title: "Request Leave in Holiday",
                    text: message,
                    icon: "error",
                    dangerMode: true,
                });
            }
         })
         .finally(() => {
            this.setState({ loading: false });
         });
   };

   onChangeLeaveType = leaveTypeId => {
      const foundLeaveType = this.state.leaveTypes.find(value => value.id === leaveTypeId);
      const leaveType = foundLeaveType?.type;

      this.setState({ selectedLeaveType: leaveType });

      if (leaveType === Enum.LEAVE_TYPE.SICK_LEAVE) {

      } else if (leaveType === Enum.LEAVE_TYPE.MATERNITY) {
         this.props.form.setFieldsValue({ numberOfWeek: 18 });
      } else if (leaveType === Enum.LEAVE_TYPE.PATERNITY_LEAVE) {
         this.props.form.setFieldsValue({ numberOfWeek: null });
         this.fetchRecentlyPaternity();
      }
   }

   onChangeStartDate = (startDate) => {
      let endDate = this.props.form.getFieldValue("endDate");

      const startShift = this.props.form.getFieldValue("startDateTime");
      const endShift = this.props.form.getFieldValue("endDateTime");
      
      if (startDate) {
         startDate = this.getStartDate(startDate, startShift);
      }
   
      this.props.form.setFieldsValue({ startDate });

      if (endDate == null && startDate) {
         endDate = this.getEndDate(startDate, endShift);
      }

      const { selectedLeaveType } = this.state;

      if (selectedLeaveType === Enum.LEAVE_TYPE.MATERNITY) {
         endDate = moment(startDate).add(126, "days");
         this.fetchEndDateOfMaternity(startDate, endDate);
      } else if (selectedLeaveType === Enum.LEAVE_TYPE.PATERNITY_LEAVE) {
         endDate = moment(startDate).add(14, "days");
         this.fetchEndDateOfMaternity(startDate, endDate);
      } else {
         this.fetchNumberOfDay(startDate, endDate,startShift,endShift);
      }

      this.props.form.setFieldsValue({ endDate });

      if (selectedLeaveType === Enum.LEAVE_TYPE.PATERNITY_LEAVE) {
         this.fetchRecentlyPaternity();
      }
   }

   onChangeEndDate = (endDate) => {
      const { selectedLeaveType } = this.state;
      const startDate = this.props.form.getFieldValue("startDate");
      const endShift = this.props.form.getFieldValue("endDateTime");
      const startDateTime = this.props.form.getFieldValue("startDateTime");

      if (endDate) {
         endDate = this.getEndDate(endDate, endShift);
      }

      this.props.form.setFieldsValue({endDate})

      this.fetchNumberOfDay(startDate, endDate,startDateTime,endShift);

      if (Enum.LEAVE_TYPE.PATERNITY_LEAVE === selectedLeaveType) {
         this.fetchRecentlyPaternity();
      }
   }

   onChangeStartTime = () => {
      const startDateTime = this.props.form.getFieldValue("startDateTime");
      const endDateTime = this.props.form.getFieldValue("endDateTime");
      const startDate = this.props.form.getFieldValue("startDate");
      const endDate = this.props.form.getFieldValue("endDate");
      if(moment(moment(startDate).format("YYYY-MM-DD")).isSame(moment(endDate).format("YYYY-MM-DD")) && startDateTime === "PM" && endDateTime === "AM"){
         swal({
            title: "Leave Request not allow!",
            icon: "error",
            dangerMode: true,
         });
         this.props.form.setFieldsValue({ startDateTime: "AM" });
         return 
      }
      
      this.onChangeStartDate(startDate);
   }

   onChangeEndTime = () => {
      const startDateTime = this.props.form.getFieldValue("startDateTime");
      const endDateTime = this.props.form.getFieldValue("endDateTime");
      const startDate = this.props.form.getFieldValue("startDate");
      const endDate = this.props.form.getFieldValue("endDate");
      if(moment(moment(startDate).format("YYYY-MM-DD")).isSame(moment(endDate).format("YYYY-MM-DD")) && startDateTime === "PM" && endDateTime === "AM"){
         swal({
            title: "Leave Request not allow!",
            icon: "error",
            dangerMode: true,
         });
         this.props.form.setFieldsValue({ endDateTime: "PM" });
         return 
      }
      this.onChangeEndDate(endDate);
   }

   onChangeNumberOfWeek = (numberOfWeek) => {
      const startDateTime = this.props.form.getFieldValue("startDateTime");
      const endDateTime = this.props.form.getFieldValue("endDateTime");
      const startDate = this.props.form.getFieldValue("startDate");
      const endDate = moment(startDate).add((numberOfWeek * 7) - 1, "days");
      this.props.form.setFieldsValue({ endDate });

      this.fetchNumberOfDay(startDate, endDate,startDateTime,endDateTime);
      this.fetchRecentlyPaternity();
   }

   render() {
      const {
         visible,
         id,
         loading,
         loadingFormData,
         numberOfDay,
         selectedLeaveType,
         leaveTypes
      } = this.state;

      return visible ? (
         <Modal
            title={id ? t("text_edit_leave_request") : t("text_new_leave_request")}
            visible={visible}
            onCancel={this.handleCancel}
         >
            <Spin spinning={loadingFormData}>
               <Form
                  form={this.props.form}
                  onFinish={this.onFinish}
                  layout="vertical"
                  key={id}
               >
                  <SelectInput
                     name="leaveItemId"
                     label={t("text_type_of_leave")}
                     placeholder={t("text_select_leave_type")}
                     valueKey="id"
                     required={true}
                     errorMessage={t("text_please_select_leave_type")}
                     dataSource={leaveTypes}
                     onChange={this.onChangeLeaveType}
                  />
                  <div style={{ display: "flex" }}>
                     <InputDate
                        name="startDate"
                        label={t("text_leave_from")}
                        required={true}
                        allowClear={true}
                        errorMessage={t("text_please_select_start_date")}
                        format="ddd DD MMM, YYYY"
                        placeholder={"ddd DD MMM, YYYY"}
                        style={{ width: 292 }}
                        onChange={this.onChangeStartDate}
                        disabledDate={this.getDisabledStartDate}
                     />
                     <SelectInput
                        name="startDateTime"
                        label={" "}
                        style={{ width: 80, marginLeft: 0, marginRight: 0 }}
                        initialValue={"AM"}
                        disabled={[Enum.LEAVE_TYPE.MATERNITY, Enum.LEAVE_TYPE.PATERNITY_LEAVE].includes(selectedLeaveType)}
                        valueKey="id"
                        dataSource={[
                           { id: "AM", name: "AM" },
                           { id: "PM", name: "PM" },
                        ]}
                        onChange={this.onChangeStartTime}
                     />
                  </div>
                  <div style={{ display: "flex" }}>
                     <InputDate
                        name="endDate"
                        label={t("text_leave_to")}
                        format="ddd DD MMM, YYYY"
                        required={true}
                        allowClear={true}
                        errorMessage={t("text_please_select_end_date")}
                        placeholder={"ddd DD MMM, YYYY"}
                        onChange={this.onChangeEndDate}
                        disabledDate={this.getDisabledEndDate}
                        style={{ width: 292 }}
                     />
                     <SelectInput
                        name="endDateTime"
                        label={" "}
                        style={{ width: 80, marginLeft: 0, marginRight: 0 }}
                        initialValue={"PM"}
                        disabled={[Enum.LEAVE_TYPE.MATERNITY, Enum.LEAVE_TYPE.PATERNITY_LEAVE].includes(selectedLeaveType)}
                        valueKey="id"
                        dataSource={[
                           { id: "AM", name: "AM" },
                           { id: "PM", name: "PM" },
                        ]}
                        onChange={this.onChangeEndTime}
                     />
                  </div>

                  {
                     [Enum.LEAVE_TYPE.MATERNITY, Enum.LEAVE_TYPE.PATERNITY_LEAVE].includes(selectedLeaveType) ?
                        <div style={{ marginLeft: 20, fontWeight: 600 }}>
                           Number of Week(s): {(this.state.numberOfDay / 7).toFixed(2)}
                        </div>
                        :
                        <div style={{ marginLeft: 20, fontWeight: 600 }}>
                           Number of Day(s): {this.state.numberOfDay}
                        </div>
                  }

                  {selectedLeaveType === Enum.LEAVE_TYPE.SICK_LEAVE && numberOfDay > 3 && <Attachment title="Doctor Certificate" callback={(fileName) => this.setState({ attachment: fileName })} />}
                  {
                     selectedLeaveType === Enum.LEAVE_TYPE.PATERNITY_LEAVE && 
                     <Attachment
                        title="Self Certificate"
                        callback={(fileName) => this.setState({ attachment: fileName })}
                     />
                  }

                  {
                     [Enum.LEAVE_TYPE.ANNUAL_LEAVE, Enum.LEAVE_TYPE.SPECIAL_LEAVE, Enum.LEAVE_TYPE.UNPAID_LEAVE].includes(selectedLeaveType) &&
                     <InputTextArea
                        name="reason"
                        label={t("text_reason")}
                        rows={2}
                        required={true}
                        placeholder={t("text_please_tell_us_about_reason_of_taking_leave")}
                        requiredMessage={t("text_please_tell_us_about_reason_of_taking_leave")}
                     />
                  }

                  <div className="ant-modal-footer2">
                     <Button
                        className="btn-cancel"
                        onClick={this.handleCancel}
                        disabled={loading}
                     >
                        {t("text_cancel")}
                     </Button>
                     <Button
                        className="btn-save"
                        type="primary"
                        htmlType="submit"
                        disabled={loading}
                        loading={loading}
                     >
                        {t("text_submit")}
                     </Button>
                  </div>
               </Form>
            </Spin>
         </Modal>
      )
         :
         <div />;
   }
}
